import { ListCommanWay } from "API/commonApi";
import React, { FC, ReactNode, useState } from "react";
import QRCode from "react-qr-code";

const TotpSetup: FC<any> = () => {
  const [qrCode, setQrCode] = useState(null);
  const [secret, setSecret] = useState("");
  const [token, setToken] = useState("");
  const [step, setStep] = useState(1);

  const handleEnable = async () => {
    ListCommanWay("/admin/auth/totp/setup", {}, {})
      .then((res) => {
        console.log(res.data.code);
        setQrCode(res.data.qr);
        setSecret(res.data.code);
        setStep(2);
      })
      .catch((c) => {
        alert(c)
      });
  };

  const handleVerify = async () => {
    ListCommanWay("/admin/auth/totp/verify", { token: token }, {})
      .then((res) => {
        console.log();
        if (res.status == "SUCCESS") {
          //alert(res.data);
          setStep(3);
        } else {
          alert("Invalid OTP");
        }
      })
      .catch((c) => {
        alert("Invalid OTP");
      });
  };

  return (
    <div>
      {step === 1 && (
        <button className="bg-blue-500 px-4 py-2 rounded-md w-full" onClick={handleEnable}>
          Enable TOTP
        </button>
      )}

      {step === 2 && (
        <>
          <div className="text-center ">
            <QRCode value={qrCode} className="w-52 h-auto mb-4 mx-auto" />

            <div className="flex items-center justify-center gap-2">
              <input
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder="Enter code from app"
                className="border p-2 rounded-md border-blue-600"
              />
              <button onClick={handleVerify} className="bg-blue-600 px-4 py-2 text-white rounded-md">
                Verify
              </button>
            </div>
          </div>
        </>
      )}

      {step === 3 && <p className="text-center">✅ TOTP Enabled</p>}
    </div>
  );
};

export default TotpSetup;
